export default "__VITE_ASSET__PMvBVaJm__"